import React, {useState} from 'react';
import Input from "../../../../UI/Input";
import Button from "../../../../UI/Button";
import {toast} from "react-toastify";

const ModalBodyEditDetails = (props) => {
    const {type, id, floatingAccountCode, title,} = props.modalData
    const [value, setValue] = useState(title)

    const clickHandler = () => {

        if (value === "") {
            toast.error("عنوان شناوری را وارد کنید")
        } else {
            props.editHandler(floatingAccountCode, value, id)
        }
    }

    return (
        <div className="float-modal-style">

            نام جدید:
            <Input id={"edit"} value={value} onChange={(e) => setValue(e.target.value)} type={"text"}/>

            <div className={"mt-5 text-center"}>
                <Button color={'pBtn'} onClick={clickHandler}> ویرایش شناوری </Button>
                <Button color={'redBtn'} onClick={props.closeModal}> لغو </Button>
            </div>
        </div>
    );
};

export default ModalBodyEditDetails;
